import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('tooltip', {
  root: {
    variants: { size: ['small', 'medium'] },
    states: ['inline'],
  },
  text: {},
});
